<template>
  <div>
    
  </div>
</template>
<script>
import { MeasurementTools } from '@/utils/tools'

export default {
  computed: {
    unit () {
      return this.$store.getters.isMeasurementMetric ? 'metric' : 'imperial'
    }
  },

  methods: {
    buildMeasurement (measurement, fromUnit, isReverse = false) {
      const { length, width, height, weight } = measurement
      if (this.unit === fromUnit) {
        return { length, width, height, weight }
      }
      
      if (isReverse) {
        return {
          length: MeasurementTools.convertMeasurementToOther(length, this.unit, fromUnit),
          width: MeasurementTools.convertMeasurementToOther(width, this.unit, fromUnit), 
          height: MeasurementTools.convertMeasurementToOther(height, this.unit, fromUnit),
          weight: MeasurementTools.convertWeightToOther(weight, this.unit, fromUnit)
        }
      }
      return {
        length: MeasurementTools.convertMeasurementToOther(length, fromUnit, this.unit),
        width: MeasurementTools.convertMeasurementToOther(width, fromUnit, this.unit),
        height: MeasurementTools.convertMeasurementToOther(height, fromUnit, this.unit),
        weight: MeasurementTools.convertWeightToOther(weight, fromUnit, this.unit)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/measurement.vue